import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLightning24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconLightning24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.749 15.271c-1.557-.004-2.334-1.886-1.233-2.987l9.733-9.73c1.312-1.311 3.495.05 2.894 1.804L14.717 8.52h4.531c1.56 0 2.34 1.885 1.238 2.987l-10 9.998c-1.316 1.315-3.504-.058-2.891-1.813l1.538-4.409zm-.172-1.926a.25.25 0 0 0 .176.426l5.438.016 1.052.003-.346.994-1.885 5.403c-.03.082-.02.134-.006.17a.27.27 0 0 0 .109.124.27.27 0 0 0 .159.043c.038-.002.089-.017.15-.078l10-9.998a.25.25 0 0 0-.176-.427h-6.63l.34-.993 1.765-5.156c.028-.082.019-.134.005-.17a.27.27 0 0 0-.109-.123.27.27 0 0 0-.159-.043c-.038.003-.089.017-.15.078z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLightning24);
